import { Component, OnInit, Input } from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormArray,
  FormControl
} from '@angular/forms';
import { UserService } from '@app/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Rol } from '@app/core/model/rol.model';

@Component({
  selector: 'app-usuario-edit',
  templateUrl: './usuario-edit.component.html',
  styleUrls: ['./usuario-edit.component.css']
})
export class UsuarioEditComponent implements OnInit {
  userForm: FormGroup;
  @Input() id: any;
  // @Input() roles3: any;
  // roles2: Rol[];
  isLoading = false;
  rols: Rol[];
  selectedRoles: any[];

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    public activeModal: NgbActiveModal
  ) {
    this.selectedRoles = Array();
  }

  ngOnInit() {
    // this.listarRoles();
    this.editForm();

    this.userService.getById(this.id).subscribe(data => {
      console.log(data);
      // this.rols = [];

      // this.categoryForm.setValue(data);
      // this.roles2 = data.roles;
      this.rols = data.roles;

      // console.log(this.roles2);
      this.userForm.setValue({
        username: data.username,
        password: '',
        email: data.email,
        nombres: data.nombres,
        apellidos: data.apellidos,
        ci: data.ci,
        celular: data.celular,
        role: data.roles
      });
      this.rols = data.roles;
      this.rols.forEach((element: Rol) => {
        // console.log(element);
        if (element.enabled === true) {
          // console.log(element.enabled);
          this.selectedRoles.push(element);
        }
      });
    });
  }
  selectRoles(e: any, id: number) {
    const modelRoles: any = {};
    if (e.target.checked) {
      modelRoles.id = id;
      modelRoles.enabled = e.target.checked;
      //  modelRoles.name = name;

      
      this.selectedRoles.push(modelRoles);
    } else {
      this.selectedRoles.splice(this.selectedRoles.indexOf(id), 1);
    }
  } // end selectRoles

  editForm() {
    this.userForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: [''],
      email: ['', [Validators.required, Validators.email]],
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      ci: ['', Validators.required],
      celular: ['', Validators.required],
      role: new FormControl('', Validators.required)
    });

    // this.addCheckboxes();
  }

  listarRoles() {
    this.userService.getAllRoles().subscribe(
      data => {
        this.rols = data;
      },
      error => {}
    );
  }

  actualizarUser() {
    const data = {
      user_id: this.id,
      username: this.userForm.value.username,
      password: this.userForm.value.password,
      email: this.userForm.value.email,
      nombres: this.userForm.value.nombres,
      apellidos: this.userForm.value.apellidos,
      ci: this.userForm.value.ci,
      celular: this.userForm.value.celular,
      roles: this.selectedRoles
    };
    console.log(data);

    this.userService.edit(data).subscribe(
      data3 => {
        alert('el usuario fue actualizado satisfactoriamente');

        this.activeModal.close(data3);
      },
      (error: any) => {
        alert('error');
      }
    );

  }
}
